import { createApp } from 'vue'
import Markdown from 'vue3-markdown-it'
import router from './router'
import App from './App.vue'
import store from './store'


createApp(App).use(Markdown).use(router).use(store).mount('#app')
